import { render } from "./IsoBookingForm.vue?vue&type=template&id=0289e044"
import script from "./IsoBookingForm.vue?vue&type=script&lang=js"
export * from "./IsoBookingForm.vue?vue&type=script&lang=js"

import exportComponent from "D:\\a\\1\\s\\Merlin.Website\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__